import {
  useUpdateGuest,
  getGuestsKey,
  getGuestKey,
  useGetGuest,
} from 'api-hooks/guest';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import LoadingComponent from 'components/common/loading';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import GuestForm from './components/form';

export type GuestViewParams = {
  id: string;
};

export default function GuestView(
  props: NavigationProps<NavigationRoutes.GuestsView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetGuest({
    id,
  });
  const { mutateAsync, error: errorMutate } = useUpdateGuest();

  const guest = data?.data;

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!errorMutate && !!errorMutate.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => errorMutate.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )}
          <GuestForm
            {...props}
            guest={guest}
            onSubmit={async (input, form) => {
              const result = await mutateAsync({
                body: input,
                guestId: guest!.id,
              });

              queryClient.refetchQueries([getGuestsKey()[0]]);
              queryClient.refetchQueries(getGuestKey({ id: guest!.id }));

              notification.success({ message: result?.message });

              return result.data;
            }}
          />
        </>
      }
    />
  );
}
